export default __webpack_public_path__ + "static/media/main.fc7011a5.jpg";